<template>
    <div>
        <div class="row mb-4">
            <div class="col-md-4">
                <overall-score-widget class="h-100 mb-0" type="cx"></overall-score-widget>
            </div>
            <div class="col-md-8">
                <trending-over-time class="h-100 mb-0" type="cx"></trending-over-time>
            </div>
        </div>
        <card class="card-default">
            <card-header>Your Customer Experience Reviews</card-header>
            <card-body class="pt-0">
                <div class="form-inline form-row"><select class="form-control ml-2 select-filter" v-model="sortBy"
                                                          @change="fetchReviews">
                    <option value="review_date|desc">Newest First</option>
                    <option value="review_date|asc">Oldest First</option>
                    <option value="rating|desc">Highest Rating</option>
                    <option value="rating|asc">Lowest Rating</option>
                </select></div>
                <grid
                        :loading="loading" style="min-height: 200px">
                    <grid-row v-for="review of reviews.data" :key="review.id">
                        <review :review="review" :type="type(review)" :tags="tags"
                                @updated="fetchReviews(page, false)"></review>
                    </grid-row>
                    <pagination class="mt-3" :meta="reviews.meta" :links="reviews.links" @page="gotoPage"></pagination>
                </grid>
            </card-body>
        </card>
    </div>
</template>

<script>
    import Review from './ReviewListItem';
    import {mapState} from 'vuex';

    export default {
        components: {Review},
        data() {
            return {
                loading: false,
                tags: [],
                page: 1,
                reviews: {
                    data: [],
                    meta: null,
                    links: null,
                },
                sortBy: 'review_date|desc'
            };
        },

        created() {
            this.fetchReviews();
            this.fetchTags();
        },

        computed: {
            ...mapState(['filter']),
        },

        watch: {
            filter() {
                this.fetchReviews();
            },
        },

        methods: {
            fetchTags() {
                return this.$http.get(this.$laroute.route('api.tags.index')).then(({data}) => this.tags = data.data);
            },

            async fetchReviews(page = 1, loading = true) {
                this.loading = loading;
                const params = {
                    ...this.filter,
                    page,
                    sortBy: this.sortBy,
                    type: 'cx'
                };
                const {data} = await this.$http.get(this.$laroute.route('api.generic-reviews.index'), {params});
                this.loading = false;
                this.reviews = data;
            },

            gotoPage(page) {
                this.fetchReviews(page);
            },

            type(review) {
                return review.campaign ? review.campaign.type : 'public';
            },
        }
    };
</script>
